import { render, staticRenderFns } from "./InsightTeam.vue?vue&type=template&id=09493511"
import script from "./InsightTeam.vue?vue&type=script&lang=js"
export * from "./InsightTeam.vue?vue&type=script&lang=js"
import style0 from "./InsightTeam.vue?vue&type=style&index=0&id=09493511&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports